import { GridLayout } from '@progress/kendo-react-layout';
import styled from 'styled-components';

const CommonPageWrapper = styled.div`
  overflow: auto;
  overflow-x: hidden;
  background-color: #ffffff;
  height: 100vh;
  width: 100%;
  padding: 20px 40px 20px 40px;
  @media print {
    height: auto !important;
    overflow: visible !important;
    width: 100% !important;
  }
  ::-webkit-scrollbar {
    height: 3px;
    margin-top: 3px;
    width: 18px;
  }

  ::-webkit-scrollbar-track {
    background: #dce4fe;
    border-radius: 0px;
    width: 18px;
  }

  ::-webkit-scrollbar-thumb {
    width: 1px;
    background: #989aa1;
    border-radius: 25px;
  }
  ::-webkit-scrollbar-corner {
    background: #dce4fe;
  }
  @media (min-height: 100px) and (max-height: 560px) {
    .sub-wrapper {
      height: 80vh;
    }
  }
`;
const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  &.btn-wrapper {
    align-items: baseline !important;
  }
  &.enter-results-heading-wrapper {
  }
  .fill-button {
    button {
      width: 138px;
    }
  }
  &.show-status {
    .center-wrapper {
      justify-content: space-between !important;
      padding-left: 30px;
    }
  }
  .search-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    .fill-button {
      padding-top: 30px;
    }
  }
  @media (max-width: 992px) {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
    .search-wrapper {
      align-items: stretch;
      gap: 15px;
      width: 100%;

      > div {
        width: calc(100% - 132px) !important;
        padding-top: 0 !important;
      }

      .fill-button {
        padding-top: 0 !important;
        width: fit-content !important;
        margin-right: 0px;

        button {
          width: 100%;
          height: 35px;
        }
      }
    }
  }
  /* Responsive styles */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;

    .search-wrapper {
      flex-direction: column;
      align-items: stretch;
      gap: 15px;

      > div {
        width: 100% !important;
        padding-top: 0 !important;
      }

      .fill-button {
        padding-top: 0 !important;
        margin-right: 0px;
        width: 100% !important;

        button {
          width: 100%;
        }
      }
    }
  }

  /* For very small screens */
  @media (max-width: 480px) {
    gap: 10px;

    .search-wrapper {
      gap: 10px;
    }
  }
`;
const CardWrapper = styled.div`
  width: 100%;
  height: max-content;
  border-radius: 6px;
  background: #ffffff;
`;
const CardSubWrapper = styled.div`
  width: 100%;
  padding: 5px 24px;
  &.d-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.end {
      justify-content: end;
      padding: 20px 24px;
    }
  }
`;
const CustomgridLayoutWrapper = styled(GridLayout)`
  &.custom-grid-wrapper {
    .multichecker-div {
      button span {
        margin-right: 20px;
        overflow-x: scroll;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        scrollbar-width: none; /* Firefox */

        &::-webkit-scrollbar {
          display: none; /* Safari and Chrome */
        }
      }
    }
  }
  .box {
    &:nth-of-type(odd) {
      padding: 0 10px 0 0;
    }
    &:nth-of-type(even) {
      padding: 0 0 0 10px;
    }
  }
  .error-msg {
    color: red;
    font-size: 12px;
    font-family: 'Inter';
  }
`;
export {
  CommonPageWrapper,
  HeadingWrapper,
  CardWrapper,
  CardSubWrapper,
  CustomgridLayoutWrapper,
};
